export const SELF_CONFIGURATION_MODE_OFF = "OFF";
export const SELF_CONFIGURATION_MODE_AWARENESS_ONLY = "AWARENESS_ONLY";
export const SELF_CONFIGURATION_MODE_AWARENESS_AND_EDIT = "AWARENESS_AND_EDIT";

export const SELF_CONFIG_AWARENESS_TOOL_NAME = "get_self_config";
export const SELF_CONFIG_EDIT_TOOL_NAME = "update_self_config";
export const SELF_CONFIGURATION_TOOL_NAMES = new Set([
  SELF_CONFIG_AWARENESS_TOOL_NAME,
  SELF_CONFIG_EDIT_TOOL_NAME,
]);

const normalizeToolList = (enabledTools) =>
  Array.isArray(enabledTools)
    ? [
        ...new Set(
          enabledTools.filter(
            (toolName) => typeof toolName === "string" && toolName.trim()
          )
        ),
      ]
    : [];

export function normalizeSelfConfigurationMode(mode) {
  const normalized = String(mode || SELF_CONFIGURATION_MODE_OFF).toUpperCase();
  if (
    normalized === SELF_CONFIGURATION_MODE_AWARENESS_ONLY ||
    normalized === SELF_CONFIGURATION_MODE_AWARENESS_AND_EDIT
  ) {
    return normalized;
  }
  return SELF_CONFIGURATION_MODE_OFF;
}

export function isSelfConfigurationAwarenessEnabled(mode) {
  return normalizeSelfConfigurationMode(mode) !== SELF_CONFIGURATION_MODE_OFF;
}

export function isSelfConfigurationEditEnabled(mode) {
  return (
    normalizeSelfConfigurationMode(mode) ===
    SELF_CONFIGURATION_MODE_AWARENESS_AND_EDIT
  );
}

export function getSelfConfigurationModeHelpText(mode) {
  const normalized = normalizeSelfConfigurationMode(mode);
  if (normalized === SELF_CONFIGURATION_MODE_OFF) {
    return "Awareness OFF: no self-config tools are exposed. Changes must be made manually in settings.";
  }
  if (normalized === SELF_CONFIGURATION_MODE_AWARENESS_ONLY) {
    return "Awareness ON, Edit OFF: the agent can inspect configuration and recommend manual changes.";
  }
  return "Awareness ON, Edit ON: the agent can inspect and update its configuration. Edits apply to subsequent runs/messages.";
}

export function deriveSelfConfigurationModeFromEnabledTools(enabledTools) {
  const dedupedTools = normalizeToolList(enabledTools);
  if (dedupedTools.includes(SELF_CONFIG_EDIT_TOOL_NAME)) {
    return SELF_CONFIGURATION_MODE_AWARENESS_AND_EDIT;
  }
  if (dedupedTools.includes(SELF_CONFIG_AWARENESS_TOOL_NAME)) {
    return SELF_CONFIGURATION_MODE_AWARENESS_ONLY;
  }
  return SELF_CONFIGURATION_MODE_OFF;
}

export function ensureSelfConfigurationToolsForMode(enabledTools, mode) {
  const normalizedMode = normalizeSelfConfigurationMode(mode);
  const dedupedTools = normalizeToolList(enabledTools);
  const toolsWithoutSelfConfig = dedupedTools.filter(
    (toolName) => !SELF_CONFIGURATION_TOOL_NAMES.has(toolName)
  );

  if (normalizedMode === SELF_CONFIGURATION_MODE_OFF) {
    return toolsWithoutSelfConfig;
  }
  if (normalizedMode === SELF_CONFIGURATION_MODE_AWARENESS_ONLY) {
    return [...toolsWithoutSelfConfig, SELF_CONFIG_AWARENESS_TOOL_NAME];
  }
  return [
    ...toolsWithoutSelfConfig,
    SELF_CONFIG_AWARENESS_TOOL_NAME,
    SELF_CONFIG_EDIT_TOOL_NAME,
  ];
}
